import React from 'react';
import CuentaCorrienteCliente from '../../Componentes/CuentaCorrienteCliente';
import './estilos.css';

function CuentaCorrienteClientePage() {
    return (
        <div className='cont-cuenteCorriente-cliente'>
            <CuentaCorrienteCliente />
        </div>
    )
}

export default CuentaCorrienteClientePage;